import { Col, Row } from "antd";
import DISTANCE from "../../../assets/images/icons/distance.svg";
import HEARTBEAT from "../../../assets/images/icons/heartbeat.svg";
import RIDES from "../../../assets/images/icons/ride.svg";
import DYNO from "../../../assets/images/icons/top-speed.svg";
import { UNITS } from "../../Common/Constants";

const Overview = ({ metaData }) => {

  return (
    <>
      <Row gutter={[16, 16]} className="mt1">
        <Col xs={24} sm={12} md={24} lg={12} xl={6}>
          <Row className="shadow-card h100">
            <Col span={24}>
              <Row>
                <Col span={24} className="flex-center">
                  <img src={RIDES} alt="Top" className="icon24 mr05 mt2 card-head-icon" />
                  <div className="card-head mt2 text-center">Active Vehicles</div>
                </Col>
                <Col span={24} className="text-center">
                  <div className="card-value mt2">
                    {metaData?.totalVehicles || 0}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={24} sm={12} md={24} lg={12} xl={6}>
          <Row className="shadow-card h100">
            <Col span={24}>
              <Row>
                <Col span={24} className="flex-center">
                  <img src={DISTANCE} alt="Scooter" className="icon24 mr05 mt2 card-head-icon" />
                  <div className="card-head mt2 text-center">Distance</div>
                </Col>
                <Col span={24} className="flex-center">
                  <div className="card-value mt2">
                    {metaData?.totalDistance || 0}
                  </div>
                  <div className="unit align-end h100 ml025 mb1">
                    {UNITS.KM}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={12}>
          <div className="shadow-card h100">
            <Row className="flex-center" justify="space-between">
              <Col span={20} className={"align-center card-head"}>
                <img src={HEARTBEAT} alt="km" className="icon24 mr1" />
                Total Heartbeat Tests
              </Col>
              <Col span={4}>
                <div className="card-test-value flex-end">
                  {metaData?.totalHeartBeatTest || 0}
                </div>
              </Col>
            </Row>
            <Row className="flex-center mt1" justify="space-between">
              <Col span={20} className={"align-center card-head"}>
                <img src={DYNO} alt="km" className="icon24 mr1" />
                Total Dyno Tests
              </Col>
              <Col span={4}>
                <div className="card-test-value flex-end">
                  {metaData?.totalDynoTest || 0}
                </div>
              </Col>
            </Row>
            <Row className="flex-center mt1" justify="space-between">
              <Col span={20} className={"align-center card-head"}>
                <img src={RIDES} alt="km" className="icon24 mr1" />
                Total Test Rides
              </Col>
              <Col span={4}>
                <div className="card-test-value flex-end">
                  {metaData?.totalTestRides || 0}
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Overview;
